export class ContainerCustomFieldValue {
    public readonly id!: string;
    public readonly field!: string;
    public readonly value!: string;
}
